export default __webpack_public_path__ + "static/media/News & Announcements.92761715.svg";